export const SHOW_FUELING_PROCESS_RECEIPT_EDIT =
  "supportui/FuelingProcessReceiptEdit/SHOW_FUELING_PROCESS_RECEIPT_EDIT";
export const HIDE_FUELING_PROCESS_RECEIPT_EDIT =
  "supportui/FuelingProcessReceiptEdit/HIDE_FUELING_PROCESS_RECEIPT_EDIT";
export const SAVE_FUELING_PROCESS_RECEIPT =
  "supportui/FuelingProcessReceiptEdit/SAVE_FUELING_PROCESS_RECEIPT";
export const SAVE_FUELING_PROCESS_RECEIPT_FAILED =
  "supportui/FuelingProcessReceiptEdit/SAVE_FUELING_PROCESS_RECEIPT_FAILED";
